import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import { styled } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

//gambar
import AddOutlined from '@mui/icons-material/AddOutlined';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

const Input = styled('input')({
    display: 'none',
});

function Metode_Bayar(props, ref) {
    //state
    const [proses, setProses] = useState(false);
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [tampil_dialog, setTampilDialog] = useState(false);
    const [sumber_metode, setSumberMetode] = useState([]);
    const [data_metode, setDataMetode] = useState([]);
    const [id_metode, setIdMetode] = useState("");
    const [nama, setNama] = useState("");
    const [data_gl, setDataGl] = useState([]);
    const [id_gl, setIdGl] = useState("");
    const [tambah_hpp, setTambahHpp] = useState(0);
    const [tambah_jual, setTambahJual] = useState(0);
    const [status, setStatus] = useState(false);
    const [label_status, setLabelStatus] = useState("Nonaktif");
    const [tampung_foto, setTampungFoto] = useState(null);
    const [foto, setFoto] = useState(null);
    const [jenis_file, setJenisFile] = useState("");
    const [nama_foto, setNamaFoto] = useState("");
    const [tampil_dialog_hapus, setTampilDialogHapus] = useState(false);

    //fungsi
    useEffect(() => {
        fetch(props.aplikasi + '/metode_bayar/tampil_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: ""
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setSumberMetode(data.data);
                    setDataMetode(data.data);
                }
                else {
                    setSumberMetode([]);
                    setDataMetode([]);
                }
            })
            .catch(error => {
                setSumberMetode([]);
                setDataMetode([]);
            }
            );

        fetch(props.aplikasi + '/metode_bayar/tampil_gl.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataGl(data.data);
                }
                else {
                    setDataGl([]);
                }
            })
            .catch(error => {
                setDataGl([]);
            }
            );
    }, [props.aplikasi]);

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const tampil_metode = () => {
        fetch(props.aplikasi + '/metode_bayar/tampil_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: ""
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setSumberMetode(data.data);
                    setDataMetode(data.data);
                }
                else {
                    setSumberMetode([]);
                    setDataMetode([]);
                }
            })
            .catch(error => {
                setSumberMetode([]);
                setDataMetode([]);
            }
            );
    }

    const cari = (event) => {
        var cari = (event.target.value).toLowerCase();
        var awal = 1;
        var akhir = sumber_metode.length;

        var posisi = 0;
        var tampung = [];
        while (awal <= akhir) {
            var hasil = ((sumber_metode[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
            if (hasil === -1) {
                hasil = ((sumber_metode[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
            }

            if (hasil !== -1) {
                tampung[posisi] = sumber_metode[awal - 1];
                posisi++;
            }
            awal++;
        }

        setDataMetode(tampung);
    }

    const bersih_input_metode = () => {
        setIdMetode("");
        setNama("");
        setIdGl("");
        setTambahHpp(0);
        setTambahJual(0);
        setStatus(false);
        setLabelStatus("Nonaktif");
        setTampungFoto(null);
        setFoto(null);
        setJenisFile("");
        setNamaFoto("");
    }

    const ubah_tambah_hpp = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        setTambahHpp(event.target.value);        
    }

    const perbaiki_tambah_hpp = (event) => {
        if (event.target.value.trim() === ""){
            setTambahHpp(0);
        }        
    }

    const ubah_tambah_jual = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        setTambahJual(event.target.value);        
    }

    const perbaiki_tambah_jual = (event) => {
        if (event.target.value.trim() === ""){
            setTambahJual(0);
        }        
    }

    const simpan = () => {
        if (nama.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Nama metode bayar wajib diisi");
            setTampilNotif(true);
            document.getElementById("nama").focus();
            return;
        }

        if (id_gl === null || id_gl.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("General Ledger wajib diisi");
            setTampilNotif(true);
            document.getElementById("gl").focus();
            return;
        }

        if (id_metode.trim() === "M1" || id_metode.trim() === "M0") {
            setJenisNotif("warning");
            setIsiNotif("Metode tunai / hutang tidak dapat dimodifikasi");
            setTampilNotif(true);
            document.getElementById("nama").focus();
            return;
        }

        setProses(true);
        if (id_metode === "") {
            fetch(props.aplikasi + '/metode_bayar/simpan_metode_bayar.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            permintaan: "simpan",
                            id_metode: "",
                            nama: nama,
                            id_gl: id_gl,
                            status: status,
                            foto: foto,
                            jenis_file: jenis_file,
                            tambah_hpp: tambah_hpp,
                            tambah_jual: tambah_jual
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        bersih_input_metode();
                        tampil_metode();
                        setJenisNotif("success");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("nama").focus();
                        setProses(false);
                    }
                    else {
                        tampil_metode();
                        setJenisNotif("warning");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("nama").focus();
                        setProses(false);
                    }
                })
                .catch(error => {
                    tampil_metode();
                    setJenisNotif("error");
                    setIsiNotif("Terjadi kesalahan");
                    setTampilNotif(true);
                    document.getElementById("nama").focus();
                    setProses(false);
                }
                );
        }
        else {
            fetch(props.aplikasi + '/metode_bayar/simpan_metode_bayar.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            permintaan: "perbarui",
                            id_metode: id_metode,
                            nama: nama,
                            id_gl: id_gl,
                            status: status,
                            foto: foto,
                            jenis_file: jenis_file,
                            tambah_hpp: tambah_hpp,
                            tambah_jual: tambah_jual
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        tampil_metode();
                        setJenisNotif("success");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("nama").focus();
                        setProses(false);
                    }
                    else {
                        tampil_metode();
                        setJenisNotif("warning");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("nama").focus();
                        setProses(false);
                    }
                })
                .catch(error => {
                    tampil_metode();
                    setJenisNotif("error");
                    setIsiNotif("Terjadi kesalahan");
                    setTampilNotif(true);
                    document.getElementById("nama").focus();
                    setProses(false);
                }
                );
        }
    }

    const hapus = () => {
        setProses(true);
        fetch(props.aplikasi + '/metode_bayar/hapus_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_metode: id_metode
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    bersih_input_metode();
                    tampil_metode();
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
                else {
                    tampil_metode();
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    document.getElementById("nama").focus();
                    setProses(false);
                }
            })
            .catch(error => {
                tampil_metode();
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
                document.getElementById("nama").focus();
                setProses(false);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                }}
            >
                <Fab
                    color="primary"
                    sx={{
                        background: "#37ce9b",
                        border: "#37ce9b",
                        margin: 0,
                        top: "auto",
                        right: 20,
                        bottom: 20,
                        left: "auto",
                        position: "fixed",
                        zIndex: "99"
                    }}
                    onClick={() => {
                        bersih_input_metode();
                        setTampilDialog(true);
                    }}
                >
                    <AddOutlined />
                </Fab>

                <Card
                    sx={{ padding: "10px" }}
                >
                    <TextField
                        id="input-with-icon-textfield"
                        label="Cari berdasarkan metode bayar"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchOutlined />
                                </InputAdornment>
                            ),
                        }}
                        onChange={cari}
                    />
                </Card>

                <Grid container spacing={1} sx={{ padding: "10px" }}>
                    {data_metode.map((data_metode) => {
                        return (
                            <Grid
                                item xs={12} sm={6} md={4} lg={3} xl={2}
                                key={data_metode.id_metode}
                                onClick={() => {
                                    bersih_input_metode();
                                    setIdMetode(data_metode.id_metode);
                                    setNama(data_metode.nama);
                                    setIdGl(data_metode.id_gl);
                                    setTambahHpp(data_metode.tambah_hpp);
                                    setTambahJual(data_metode.tambah_jual);
                                    if (data_metode.status === "1") {
                                        setStatus(true);
                                        setLabelStatus("Aktif");
                                    }
                                    else {
                                        setStatus(false);
                                        setLabelStatus("Nonaktif");
                                    }
                                    setNamaFoto(data_metode.foto);
                                    setTampilDialog(true);
                                }}
                            >
                                <Card>
                                    <List>
                                        <ListItem button>
                                            <ListItemAvatar>
                                                <Avatar
                                                    alt={data_metode.nama}
                                                    src={props.file + "/Foto/Metode Bayar/" + data_metode.foto}
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body1" noWrap>{data_metode.nama}</Typography>
                                                }
                                            >
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>

            <Dialog
                open={tampil_dialog}
                onClose={() => setTampilDialog(false)}
            >
                <DialogTitle>Input Data Metode Bayar</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <center>
                            <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                badgeContent={
                                    <label htmlFor="icon-button-file">
                                        <Input accept="image/*" id="icon-button-file" type="file"
                                            onChange={(e) => {
                                                setFoto(e.target.files[0]);
                                                setTampungFoto(e.target.files[0]);
                                                setJenisFile(e.target.files[0].name.split(".").pop());
                                                let reader = new FileReader();
                                                reader.readAsDataURL(e.target.files[0]);
                                                reader.onload = () => {
                                                    setFoto(reader.result);
                                                }
                                            }}
                                        />
                                        <Fab
                                            size="small"
                                            color="primary"
                                            component="span"
                                        >
                                            <PhotoCamera />
                                        </Fab>
                                    </label>
                                }
                            >
                                <Avatar
                                    src={tampung_foto !== null ? URL.createObjectURL(tampung_foto) : props.file + "/Foto/Metode Bayar/" + nama_foto}
                                    sx={{ width: 128, height: 128 }}
                                />
                            </Badge>
                        </center>
                        <br />
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={5}>
                                    <Typography variant="body2">
                                        Nama Metode Bayar
                                    </Typography>
                                </Grid>

                                <Grid item xs={7}>
                                    <TextField
                                        id="nama"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        value={nama}
                                        onChange={(event) => setNama(event.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5}>
                                    <Typography variant="body2">
                                        General Ledger
                                    </Typography>
                                </Grid>

                                <Grid item xs={7}>
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            id="gl"
                                            variant="outlined"
                                            fullWidth
                                            value={id_gl}
                                            onChange={(event) => setIdGl(event.target.value)}
                                        >
                                            {data_gl.map((data_gl) => {
                                                return (
                                                    <MenuItem key={data_gl.id_gl} value={data_gl.id_gl}>{data_gl.gl}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            {/* <Grid container item>
                                <Grid item xs={5}>
                                    <Typography variant="body2">
                                        Penambahan HPP (%)
                                    </Typography>
                                </Grid>

                                <Grid item xs={7}>
                                    <TextField
                                        id="tambah_hpp"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        value={tambah_hpp}
                                        onChange={(e) => ubah_tambah_hpp(e)}
                                        onBlur={(e) => perbaiki_tambah_hpp(e)}
                                    />
                                </Grid>
                            </Grid> */}

                            <Grid container item>
                                <Grid item xs={5}>
                                    <Typography variant="body2">
                                        Penambahan Harga Jual (%)
                                    </Typography>
                                </Grid>

                                <Grid item xs={7}>
                                    <TextField
                                        id="tambah_jual"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        value={tambah_jual}
                                        onChange={(e) => ubah_tambah_jual(e)}
                                        onBlur={(e) => perbaiki_tambah_jual(e)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5}>
                                    <Typography variant="body2">
                                        Status
                                    </Typography>
                                </Grid>

                                <Grid item xs={7}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={status}
                                                onChange={(event) => {
                                                    if (status === false) {
                                                        setStatus(true);
                                                        setLabelStatus("Aktif");
                                                    }
                                                    else {
                                                        setStatus(false);
                                                        setLabelStatus("Nonaktif");
                                                    }
                                                }}
                                            />
                                        }

                                        label={label_status}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<SaveOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em" }}
                        loading={proses}
                        onClick={() => simpan()}
                    >
                        <Typography variant="body2" noWrap={true}>{id_metode === "" ? "Simpan" : "Perbarui"}</Typography>
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "red" }}
                        loading={proses}
                        onClick={() => {
                            if (id_metode.trim() === "M1") {
                                setJenisNotif("warning");
                                setIsiNotif("Metode tunai tidak dapat dihapus");
                                setTampilNotif(true);
                                document.getElementById("nama").focus();
                                return;
                            }

                            setTampilDialogHapus(true);
                        }}
                    >
                        <Typography variant="body2" noWrap={true}>Hapus</Typography>
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<CloseOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        loading={proses}
                        onClick={() => setTampilDialog(false)}
                    >
                        <Typography variant="body2" noWrap={true}>Tutup</Typography>
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_hapus}
                onClose={() => setTampilDialogHapus(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Hapus Metode Bayar
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin menghapus data ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton 
                        loadingPosition="start"
                        loading={proses}
                        onClick={() => setTampilDialogHapus(false)} 
                        autoFocus
                    >
                        Tidak
                    </LoadingButton>
                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        onClick={() => {
                            setTampilDialogHapus(false);
                            setTampilDialog(false);
                            hapus();
                        }}
                    >
                        Ya
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default forwardRef(Metode_Bayar);